import { ChangeEvent, FC, useCallback } from 'react';
import { useSelector } from 'react-redux';

import { Icon, MaskField } from '@beeline/design-system-react/extracted-styles';
import { Icons } from '@beeline/design-tokens/js/iconfont';

import { getParkingState } from 'src/store/parking/selectors';
import { parkingActions } from 'src/store/parking/slice';
import { useAppDispatch } from 'src/store/useAppDispatch';

const mask = {
  mask: 'HH:MM—HH:MM',
  blocks: {
    HH: {
      // @ts-expect-error global
      mask: IMask.MaskedRange,
      from: 0,
      to: 23,
      minLength: 2,
    },
    MM: {
      // @ts-expect-error global
      mask: IMask.MaskedRange,
      from: 0,
      to: 59,
      minLength: 2,
    },
  },
};

export const ParkingBookingTimeField: FC = () => {
  const dispatch = useAppDispatch();
  const { date, time, timeError, backgroundData } =
    useSelector(getParkingState);

  const dateDisabled = !backgroundData;
  const timeDisabled = dateDisabled || !date;

  const setTime = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      dispatch(parkingActions.setTime(event.target.value));
    },
    [dispatch],
  );

  return (
    <MaskField
      label='Время'
      startAdornment={<Icon iconName={Icons.Clock} />}
      maskConfig={mask}
      value={time}
      onInput={setTime}
      placeholder='чч:мм—чч:мм'
      error={!!timeError}
      helperText={timeError}
      disabled={timeDisabled}
      fullWidth
      dataTestId='parkingBookingTime'
    />
  );
};
